import { SingleSelect } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


export const fontWeightOptions = {
	'100': '100',
	'200': '200',
	'300': '300',
	'400': '400',
	'500': '500',
	'600': '600',
	'700': '700',
	'800': '800',
	'900': '900',
	normal: 'Normal',
	bold: 'Bold',
};


export function FontWeight()
{
	return (
		<StyleFieldsRow>
			<FontWeightFields />
		</StyleFieldsRow>
	);
}


/* The weight on its own, for a caller that names the location itself - see ruleProperties(). */
export function FontWeightFields()
{
	return (
		<LabelOnLeftWrap label='' narrow={true}>
			<SingleSelect field='weight' options={fontWeightOptions} />
		</LabelOnLeftWrap>
	);
}
